module.exports = __webpack_public_path__ + "fonts/DM_Sans-400-latin-ext8.49935c4.woff2";